export default function (value) {
  if (value === 0) return '0 extra\'s';
  if (value === 1) return `${value} extra`;
  return `${value} extra's`;
}
